/* ShowRoom MeenGrlz — MVP landing sections. Works with Impulse's native main-product section.
   Color buttons click the theme's own variant swatches, so price, stock, Affirm and checkout stay native. */
(function () {
  if (window.__mvpLanding) return;
  window.__mvpLanding = true;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && Shopify.designMode;

  function mainSection() {
    return document.querySelector('[id$="__main"]') || document.querySelector('[data-section-type="product"]');
  }
  function pickColor(color) {
    var inputs = document.querySelectorAll('input[data-variant-input]');
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      if (inp.value === color && !inp.closest('.mvp-s')) {
        if (!inp.checked) {
          var lab = document.querySelector('label[for="' + inp.id + '"]');
          (lab || inp).click();
        }
        return;
      }
    }
  }
  function headerOffset() {
    var h = document.querySelector('.site-header') || document.querySelector('[data-section-type="header"]');
    return h ? Math.min(h.getBoundingClientRect().height, 200) : 0;
  }
  function toBuy() {
    var m = mainSection();
    if (!m) return;
    var top = m.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 12;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
  }
  function sizeHero() {
    var hero = document.querySelector('.mvp-hero');
    if (!hero) return;
    var t = hero.getBoundingClientRect().top + window.pageYOffset;
    hero.style.setProperty('--mvp-hero-top', Math.max(0, Math.min(t, 320)) + 'px');
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-mvp-color],[data-mvp-buy]');
    if (!el) return;
    e.preventDefault();
    if (el.getAttribute('data-mvp-color')) pickColor(el.getAttribute('data-mvp-color'));
    toBuy();
  });

  function initCompare(root) {
    root.querySelectorAll('.mvp-compare').forEach(function (cmp) {
      if (cmp.__mvp) return; cmp.__mvp = true;
      var rng = cmp.querySelector('.mvp-compare__range');
      rng.addEventListener('input', function () { cmp.style.setProperty('--pos', rng.value + '%'); });
      if (reduce || design || !('IntersectionObserver' in window)) return;
      var done = false;
      new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting || done) return;
          done = true; var t0 = null;
          (function step(ts) {
            if (!t0) t0 = ts; var p = Math.min(1, (ts - t0) / 1600);
            var v = 50 + Math.sin(p * Math.PI * 2) * 22;
            cmp.style.setProperty('--pos', v + '%'); rng.value = v;
            if (p < 1) requestAnimationFrame(step); else { cmp.style.setProperty('--pos', '50%'); rng.value = 50; }
          })(performance.now());
        });
      }, { threshold: 0.55 }).observe(cmp);
    });
  }

  function initHotspots(root) {
    root.querySelectorAll('.mvp-details').forEach(function (sec) {
      if (sec.__mvp) return; sec.__mvp = true;
      function hot(i) {
        sec.querySelectorAll('[data-hot]').forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-hot') == i); });
      }
      sec.querySelectorAll('[data-hot]').forEach(function (el) {
        el.addEventListener('click', function () { hot(el.getAttribute('data-hot')); });
        el.addEventListener('mouseenter', function () { hot(el.getAttribute('data-hot')); });
      });
      hot(0);
    });
  }

  function initReveals(root) {
    if (design || reduce || !('IntersectionObserver' in window)) return;
    var sel = '.mvp-sechead,.mvp-ways__notes > div,.mvp-feat li,.mvp-fit__fig,.mvp-fit__chart,.mvp-formula,.mvp-faq__list details,.mvp-details__copy > .mvp-h,.mvp-style__copy > .mvp-h';
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    root.querySelectorAll(sel).forEach(function (el, i) {
      if (el.classList.contains('mvp-rv')) return;
      el.classList.add('mvp-rv'); el.style.transitionDelay = (i % 4) * 90 + 'ms'; io.observe(el);
    });
  }

  function initDock() {
    var dock = document.querySelector('.mvp-dock');
    if (!dock || dock.__mvp) return; dock.__mvp = true;
    var meta = dock.querySelector('[data-mvp-dock-meta]');
    var base = meta ? meta.textContent : '';
    function updateMeta() {
      if (!meta) return;
      var checked = Array.prototype.filter.call(document.querySelectorAll('input[data-variant-input]:checked'), function (x) { return !x.closest('.mvp-s'); });
      var color = checked.filter(function (x) { return x.hasAttribute('data-color-name'); })[0];
      meta.textContent = color ? color.value + ' · ' + base.split('·').pop().trim() : base;
    }
    document.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('input[data-variant-input]')) setTimeout(updateMeta, 30); });
    updateMeta();
    if (!('IntersectionObserver' in window)) return;
    var buyVis = false, pastHero = false;
    function upd() { var on = pastHero && !buyVis; dock.classList.toggle('is-on', on); dock.setAttribute('aria-hidden', on ? 'false' : 'true'); }
    var hero = document.querySelector('.mvp-hero');
    var m = mainSection();
    var target = (m && (m.querySelector('[name="add"]') || m.querySelector('form[action*="/cart/add"]'))) || m;
    if (target) new IntersectionObserver(function (es) { buyVis = es[0].isIntersecting; upd(); }, { threshold: 0.01 }).observe(target);
    if (hero) new IntersectionObserver(function (es) { pastHero = !es[0].isIntersecting; upd(); }).observe(hero);
    else { pastHero = true; upd(); }
  }

  function init(root) { sizeHero(); initCompare(root); initHotspots(root); initReveals(root); initDock(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
